export const ds_NewsListingBlock_Entry = `
    fragment ds_NewsListingBlock_Entry on ds_NewsListingBlock_Entry {
        id
        canonicalUid

        newsListing_TopSpacing
        newsListing_HeadingAndTextAlignment
        newsListing_FullWidthBackground
        newsListing_ContainerWidth
        newsListing_ColorTheme
        newsListing_ColorPalette

        newsListing_Heading
        newsListing_BodyText

        newsListing_Category {
            id
            slug
        }
    }
`